const removeUnderscores = str => str.replace(/_/g, '');

const formatAddressArray = addresses =>
  addresses.map(address =>
    Object.fromEntries(
      Object.entries(address).map(([key, value]) => [
        removeUnderscores(key),
        value,
      ]),
    ),
  );

const transformAddresses = addresses =>
  addresses.map(({ shortname }) => ({
    label: shortname,
    value: shortname,
  }));

const findSelectedAddress = (id, value, addresses, placeholder) => {
  if (value === placeholder) return null;

  const selectedAddress = addresses.find(
    address => address.shortname === value,
  );

  if (!selectedAddress) return null;

  /**
   * First check if line1 contains a number
   * then split at the comma, example address line FLAT 123, 45, MAIN ROAD
   * if no comma, split on or after the first number
   * Flat 123 / MAIN ROAD
   * 106B / SIDE STREET
   */
  const { line1, shortname } = selectedAddress;
  const hasNumber = /\d/;
  const startsWithNumber = /^\d/;
  const splitOnFirstNumber = /^(\S+)\s+(.+)/;
  const splitAfterNumber = /^(.+\d+)\s+(.+)$/;
  let houseNum;
  let address;

  // If theres a number and line1 is more than one string
  if (hasNumber.test(line1) && line1.split(' ').length > 1) {
    // If address is comma serperated
    if (line1.includes(',')) {
      line1.split(',').map(item => item.trim());
      // If address stars with a number
    } else if (startsWithNumber.test(line1)) {
      [houseNum, address] = line1.split(splitOnFirstNumber).slice(1);
    } else {
      // If address starts with string
      [houseNum, address] = line1.match(splitAfterNumber).slice(1);
    }

    /**
     * If no number is found then we split the shortname on ','
     * and set the number as the house name and the second index to address
     * for example Chapel House, Walcot
     */
  } else {
    [houseNum, address] = shortname.split(',');
  }

  // Add the new split house name/number and address line 1 back with other address details
  const updatedAddress = {
    ...selectedAddress,
    number: houseNum.trim(),
    line1: address.trim(),
  };

  // Modify the address to pass through the prefix value with each key
  const modifiedAddress = {};
  Object.keys(updatedAddress).forEach(key => {
    modifiedAddress[`${id}${key.charAt(0).toUpperCase()}${key.slice(1)}`] =
      updatedAddress[key];
  });

  return modifiedAddress;
};

const resetFieldValidationAndErrors =
  (setValue, clearErrors) =>
  (inputField, validationField, disableValidation = true) => {
    setValue(validationField, disableValidation);
    clearErrors(inputField);
  };

// Check that address data is present, so it can be persisted within the fields
const dataIsFilled = (data, keysToCheck) => {
  if (!data) return false;

  return keysToCheck.every(
    key => data[key] !== '' && data[key] !== undefined && data[key] !== null,
  );
};

const persistedDataIsFilled = data => {
  const keysToCheck = [
    'house_number',
    'address_line_1',
    'address_line_4',
    'postcode',
  ];

  return dataIsFilled(data, keysToCheck);
};

const selectedAddressIsFilled = (data, prefix) => {
  const keysToCheck = [`${prefix}Postcode`];

  return dataIsFilled(data, keysToCheck);
};

// Compare address data objects
const compareAddresses = (addressOne, addressTwo) => {
  const keysToCheck = ['address_line_1', 'postcode'];

  if (!addressOne || !addressTwo) return false;

  return keysToCheck.every(key => addressOne[key] === addressTwo[key]);
};

export {
  formatAddressArray,
  transformAddresses,
  findSelectedAddress,
  resetFieldValidationAndErrors,
  persistedDataIsFilled,
  selectedAddressIsFilled,
  compareAddresses,
};
